<template>
    <div class="avatar-box">
        <div class="avatar-box__img">
            <img v-if="avatar" :src="avatar">
            <i v-else class="iconfont">&#xe6a7;</i>
        </div>
        <div v-if="auth" class="avatar-box__auth">
            <i class="iconfont">&#xe634;</i>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'AvatarBox',
    props: {
      avatar: {   // 头像 img url
        default: ''
      },
      auth: { // 是否显示认证图标
        type: Number,
        default: 0
      }
    },
    created(){
        // console.log(this.avatar)
    }
  }
</script>
<style lang="less">
.avatar-box{
    position: relative;
    margin-right: .15rem;
    width: .4rem; height: .4rem; 
    &__img{
        width: 100%; height: 100%; line-height: .4rem;
        text-align: center;
        background-color: #f6f6f6;
        border-radius: 50%;
        overflow: hidden;
        &>.iconfont{
            color: #ccc;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
        }
        &>img{
            width: 100%; height: 100%;
            object-fit: cover;
            filter: blur(0px);
        }
    }
    &__auth{
        position: absolute;
        right: 0; bottom: 0;
        &>.iconfont{
            color: #F1C232;
            font-size: .12rem;
            width: 0.14rem;
            height: 0.14rem;
            line-height: 0.14rem;
            border-radius: 50%;
            background-color: white;
            display: block;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/AvatarBox.vue